import classes from './About.module.css';

const About = () => {
  return (
    <div className={classes.aboutContainer} >
      <div className={classes.sectionContainer}>
        <span>About Me</span>

        <div>
          Hi there! I'm Rahul, a passionate web developer with a strong focus on
          creating dynamic and innovative websites. I have a keen interest in
          exploring various frameworks and technologies in web development.
        </div>
      </div>

      <div className={classes.sectionContainer}>
        <span>My Journey</span>

        <div>
          Leveraging my experience with MERN stack, I have built robust web
          applications for small businesses and captivating websites for college
          events, delivering tailored user experiences. I've also expanded my
          skills by developing an Android app that applies deep learning to
          classify skin diseases. This cross-disciplinary approach has allowed
          me to tackle diverse challenges and grow my expertise.
        </div>
      </div>

      <div className={classes.sectionContainer}>
        <span>Strengths</span>

        <div>
          As a smart worker, I find joy in coding and solving complex bugs. I
          excel in prompt engineering, ensuring timely delivery and attention to
          detail in every project I undertake.
        </div>
      </div>

      <div className={classes.sectionContainer}>
        <span>Passion for Learning</span>

        <div>
          One of my defining qualities is my fascination with technology. I am
          always eager to learn new technologies, staying updated with the
          latest advancements in the field. This enthusiasm enables me to
          embrace cutting-edge tools and frameworks, ensuring I deliver the best
          solutions to clients. If you're looking for a dedicated and versatile
          web developer who loves to stay on the forefront of technology, I'm
          here to bring your ideas to life.
        </div>
      </div>
      <br />
    </div>
  );
};
export default About;
